import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import { FormattedMessage, defineMessages } from 'react-intl';
import Menu from '../Menu';
import PageTitle from '../PageTitle';
import { active } from './styles.css';

const messages = defineMessages({
  meritScholarships: {
    id: 'scholarships.view.merit-scholarships',
    defaultMessage: 'Merit Scholarships',
  },
});

function getScholarshipsTabActiveClass(router) {
  return router.location.pathname.includes('/college-scholarships/merit-scholarships/') ? active : '';
}

const scholarshipsFrame = (props) => (
  <div styleName="container">
    <PageTitle title="Scholarships" category="Presence" />
    <nav aria-label="Scholarships Menu">
      <Menu stackable as="ul" pointing secondary size="huge" styleName="menu">
        <Menu.Item as="li" link styleName="menu-item">
          <Link
            to="/college-scholarships/merit-scholarships"
            styleName="menu-link"
            className={getScholarshipsTabActiveClass(props.router)}
            activeClassName={active}
            data-cy="merit-scholarships-link"
          >
            <FormattedMessage {...messages.meritScholarships} />
          </Link>
        </Menu.Item>
      </Menu>
    </nav>
    <main aria-labelledby="pageTitle" styleName="content" id="content">
      {props.children}
    </main>
  </div>
);

scholarshipsFrame.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.object.isRequired,
  }).isRequired,
  children: PropTypes.node,
};

export default withRouter(scholarshipsFrame);
